






















































import Component from "vue-class-component";
import Vue from "vue";
import OrderItem from "./module/orderItem.vue";
import moduleStore from "./store/index";
import OrderA from "./module/orderA.vue";
import OrderB from "./module/orderB.vue";
import OrderC from "./module/orderC.vue";
@Component({
  components: { OrderItem, OrderA, OrderB, OrderC },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class indexPage extends Vue {
  orderList = [0, 1, 2, 3, 4, 5];
  curItemIndex = 0;
  ComArr = ["OrderA", "OrderB", "OrderC"];
  Com = "OrderA";
  currentDate = new Date();
  showDate = new Date().format("yyyy (MM月)");
  maxDate = new Date();
  pickerShow=false
  created() {
    localStorage.setItem("ww_token", this.$route?.query.ww_token as string);
  }
  mounted() {
    this.$bus.$on("reSelctTime",()=>{
      this.pickerShow = true
    })
  }
  changeItem(index) {
    this.curItemIndex = index;
    this.Com = this.ComArr[index];
    this.$nextTick(()=>{
      let orderCo: any =this.$refs.orderCo
      orderCo.onRefresh()
    })

  }
  formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    }
   queryRecord(){

   }
   DatetimePicker(){
    this.$nextTick(()=>{
      this.showDate = this.currentDate.format("yyyy (MM月)")
      let orderCo: any =this.$refs.orderCo
      orderCo.onRefresh()
      this.pickerShow = false
    })
   }
}
